import { FormControlLabel, Grid, RadioGroup, } from "@mui/material";
import React from "react";
import CustomAutoComplete from "ui-components/CustomAutoComplete";
import CustomPhone from "ui-components/CustomPhone";
import CustomUrlField from "ui-components/CustomUrlField";
import CustomInputField from "ui-components/formik/CustomInputField";
import { AddStartup, FetchAllBusinessModel, FetchAllCategories, FetchAllCities, FetchAllCountries, FetchAllCountriesWithPhoneCodes, FetchAllStages, FetchAllStates, FetchAllSubCategories, FetchStartupDetails } from "api";
import { ReactComponent as gpsIcon } from "assets/gps.svg"
import { useFormikContext } from "formik";
import CustomLogoButton from 'ui-components/formik/CustomLogoButton'
// import placeHolderImage from "assets/placeholder_image.png"
import LogoPlaceholder from "assets/logo_placeholder.svg"
import CustomLabel from "ui-components/CustomLabel";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import CustomValidationText from "ui-components/CustomValidationText";
import CustomRadio from "ui-components/CustomRadio";
import OptionChipGroup from "ui-components/OptionChip";
import { FetchViewStartupDetails } from "api/backrr_startups";




const StartupInformation = ({ isStartupDetailsLoading = false }) => {
  const formik = useFormikContext()
  const [currentSubCategory, setCurrentSubCategory] = React.useState('');
  const [searchSubCategory, setSearchSubCategory] = React.useState('');
  // Must be an ARRAY: FetchAllSubCategories does `Array.isArray(category) ? ... : []`,
  // so a plain string silently resolved to no categories and the Sector dropdown always
  // said "No Options". Profile/UpdateProfile passes an array, which is why it works there.
  const [selectedCategory, setSelectedCategory] = React.useState([]);
  const [currentBusinessModel, setCurrentBusinessModel] = React.useState('');
  const [searchBusinessModel, setSearchBusinessModel] = React.useState('');
  // const [selectedBusinessModel, setSelectedBusinessModel] = React.useState("");


  const { data: startup_categories, isRefetching: isRefetchingCategories, isLoading: isLoadingCategories, refetch: refetchCategories } = FetchAllCategories()
  const { data: startup_stages, isRefetching: isRefetchingRoundTypes, isLoading: isLoadingRoundTypes, refetch: refetchRoundTypes } = FetchAllStages("round");
  const { data: startup_sub_categories, isRefetching: isRefetchingSubCategories, isLoading: isLoadingSubCategories, refetch: refetchSubCategories } = FetchAllSubCategories({ category: selectedCategory })
  // const { data: startupDetailsData, isLoading: isStartupDetailsLoading, refetch: refetchStartupDetails } = FetchViewStartupDetails()
  const { data: startup_business_model, isRefetching: isRefetchingBusinessModel, isLoading: isLoadingBusinessModel, refetch: refetchBusinessModel } = FetchAllBusinessModel({})

  const isLoading = (isStartupDetailsLoading) || isLoadingRoundTypes;
  // Effect to set selected category based on formik values
  React.useEffect(() => {
    if (!isStartupDetailsLoading && !isLoadingCategories && formik.values && Array.isArray(startup_categories)) {
      const category = startup_categories.find(item => item?._id === formik?.values?.category_id);
      if (category) {
        setSelectedCategory([category.name]);
      }
    }
  }, [isStartupDetailsLoading, isLoadingCategories, formik.values, startup_categories, formik?.values?.category_id]);

  // Effect to refetch subcategories when selectedCategory changes
  React.useEffect(() => {
    if (!isRefetchingCategories && !isLoadingCategories && selectedCategory) {
      refetchSubCategories();
    }
  }, [selectedCategory, isRefetchingCategories || isLoadingCategories,]);

  React.useEffect(() => {
    if (formik.values.sector_id && startup_sub_categories) {
      const matchedSubCategory = startup_sub_categories.find(subCat => subCat._id === formik.values.sector_id);
      if (matchedSubCategory) {
        setCurrentSubCategory({ label: matchedSubCategory?.sub_category, value: matchedSubCategory?._id, description: matchedSubCategory?.description });
      }
    }
  }, [formik.values.sector_id, startup_sub_categories]);
  React.useEffect(() => {
    if (!isLoading && !isLoadingBusinessModel && formik?.values && Array.isArray(startup_business_model) && Array.isArray(formik?.values.business_model_id)) {
      const businessModel = startup_business_model?.filter(item => formik?.values?.business_model_id?.includes(item?._id));
      if (businessModel.length) {
        setCurrentBusinessModel(
          businessModel.map(item => ({
            label: item?.name,
            value: item?._id,
            description: item?.description,
          }))
        );
      }
    }
  }, [isLoading, isLoadingBusinessModel, formik?.values, startup_business_model, formik?.values?.business_model_id]);

  const handleSearchSubCategoryChange = (event, value) => {
    // console.log(event.target.value, value,"ca")
    setSearchSubCategory(value);
    // refetchCities();
  };
  const handleSelectionSubCategoryChange = (event, sector) => {
    // console.log(value, "value")
    formik.setFieldValue("sector_id", sector ? sector?.value : '');
    setCurrentSubCategory(sector)
    event.preventDefault();
  };
  const handleSearchUpdateSubCategory = () => {
    refetchSubCategories();
  }
  const handleSearchBusinessModelChange = (event, value) => {
    // console.log(event.target.value, value,"ca")
    setSearchBusinessModel(value);
    // refetchCities();
  };
  const handleSelectionBusinessModelChange = (event, businessModel) => {
    formik.setFieldValue("business_model_id", businessModel ? businessModel?.map(item => item?.value) : []);
    setCurrentBusinessModel(businessModel)
    event.preventDefault();
  };
  const handleSearchUpdateBusinessModel = () => {
    refetchBusinessModel();
  }
  const availableOptions = startup_business_model?.filter(
    item =>
      !(currentBusinessModel || []).some(selected => selected.value === item._id)
  ) || [];
  return (
    <>
      {/* Two-column field layout, matching startup-web's update?page=0: short fields
          sit sm={6} rather than each taking a whole row. */}
      <Grid height={"min-content"} item xs={12} sm={6}>
        <CustomInputField name={`email`} label={"email"} placeholder={"Enter email"} value={formik.values?.email} onChange={(e) => formik.setFieldValue(`email`, String(e.target.value)?.toLowerCase())} fullWidth />
      </Grid>
      <Grid item xs={12} sm={12} mb={2}>
        {/* Gradient placeholder + 72px box, same as startup-web's update?page=0. The old
            blue PNG was the generic no-data startup image, not the upload placeholder. */}
        <CustomLogoButton label="LOGO" handleUpdateFile={(file) => { formik.setFieldValue("startup_logo", file) }} name={"startup_logo"} value={formik.values?.startup_logo} placeholder={LogoPlaceholder} Pheight={72} Pwidth={72} />
        {/* <CustomUploadButton label="LOGO" handleUpdateFile={(evt) => { formik.setFieldValue("startup_logo", evt.target.files[0]) }} selectedFile={formik.values.startup_logo} /> */}
      </Grid>
      <Grid item xs={12} sm={6} height={"min-content"}>
        <CustomInputField
          name={`startup_name`}
          label={"STARTUP NAME"}
          placeholder={"Enter startup name"}
          value={formik.values?.startup_name}
          onChange={(e) =>
            (e.target.value?.length <= 30) && formik.setFieldValue(
              `startup_name`,
              e.target.value?.charAt(0)?.toUpperCase() +
              e.target.value?.slice(1)
            )
          }
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomInputField value={formik.values.entity_name} label={"LEGAL ENTITY NAME"} placeholder={"Enter legal entity name"} name="entity_name" onChange={(e) => formik.setFieldValue("entity_name", e.target.value?.charAt(0)?.toUpperCase() + e.target.value?.slice(1))} fullWidth />
      </Grid>
      <Grid item xs={12} sm={6} paddingBottom={2}>
        {/* {console.log(formik.values?.formation_date,"formik.values?.formation_date")} */}
        <CustomLabel>FORMATION DATE</CustomLabel>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            label=""
            sx={{ width: "100%", background: "#fff", marginBottom: 0 }}
            // Border/radius copied from startup-web's picker so it matches the text
            // fields beside it (the `&&` overrides on the page only reach Filled/Outlined
            // inputs, not the picker's own v7 classes).
            slotProps={{
              textField: {
                fullWidth: true,
                sx: {
                  background: "#fff",
                  "& .MuiPickersOutlinedInput-root, & .MuiOutlinedInput-root": { borderRadius: "10px" },
                  "& .MuiPickersOutlinedInput-notchedOutline, & .MuiOutlinedInput-notchedOutline": { borderColor: "#E4E7EC" },
                  "&:hover .MuiPickersOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#E4E7EC" },
                  "& .MuiPickersOutlinedInput-root.Mui-focused .MuiPickersOutlinedInput-notchedOutline, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#101828", borderWidth: "1px" },
                },
              },
            }}
            // Parse the ISO string to a Moment object
            value={formik.values?.formation_date ? moment(formik.values.formation_date) : null}
            disableFuture={true}
            onChange={(date) => {
              // if (date?.isValid()) {
              // Convert Moment object back to ISO string
              formik.setFieldValue('formation_date', date != null ? date.toISOString() : null);
              // }
            }}
            renderInput={(params) => (
              <CustomInputField
                sx={{ padding: "10px 14px" }}
                disabled
                fullWidth
                {...params}
              />
            )}
            inputFormat="DD/MM/YYYY"
            autoComplete="off"
          />
        </LocalizationProvider>
        {formik.errors?.formation_date && <CustomValidationText value={formik.errors.formation_date} />}
        {/* )
                                                    } */}
      </Grid>
      <Grid item container xs={12} gap={1} display={"flex"} paddingBottom={2}>
        <Grid item xs={12}>
          <CustomLabel sx={{ marginBlock: "0rem" }}>WHAT IS THE STAGE OF YOUR STARTUP? {formik.errors.stage_id && (
            <CustomValidationText value={formik.errors.stage_id} style={{textTransform: 'none'}} />
          )}</CustomLabel>
        </Grid>

        {/* Same chips startup-web's update?page=0 uses for stage. Single-select, so the
            indicator is a radio. Replaces the yellow image tiles. */}
        <Grid item xs={12}>
          <OptionChipGroup
            options={Array.isArray(startup_stages) ? startup_stages : []}
            value={formik.values?.stage_id}
            onChange={(value) => formik.setFieldValue("stage_id", value)}
          />
        </Grid>

        {/* <Grid item xs={12} lg={12} mt={1} height={"min-content"}>
                                <CustomLabel>
                                  HAVE YOU RAISED FUNDS EARLIER?
                                </CustomLabel>
                                <RadioGroup
                                  sx={{ flexDirection: "row", paddingBottom: 0 }}
                                  name="raised_round"
                                  value={formik.values?.raised_round}
                                  onChange={(e) =>
                                    formik.setFieldValue(
                                      `raised_round`,
                                      e.target.value
                                    )
                                  }
                                >
                                  <FormControlLabel
                                    value={true}
                                    control={<CustomRadio disableRipple />}
                                    label={"Yes"}
                                  />
                                  <FormControlLabel
                                    value={false}
                                    control={<CustomRadio disableRipple />}
                                    label={"No"}
                                  />
                                </RadioGroup>
                              </Grid> */}
      </Grid>
      <Grid item xs={12}>
        <CustomLabel sx={{ marginTop: "0rem" }}>Select Category {formik.errors?.category_id && (
          <CustomValidationText value={formik.errors?.category_id} style={{textTransform: 'none'}} />
        )}</CustomLabel>
      </Grid>
      {/* Category is single-select here (category_id holds one id), so the chips carry a
          radio indicator, same as startup-web. Selecting one still resets the sector,
          exactly as the old tiles did. */}
      <Grid item xs={12} paddingBottom={{ xs: 1 }}>
        <OptionChipGroup
          options={Array.isArray(startup_categories) ? startup_categories : []}
          value={formik?.values?.category_id}
          // Explicit _id: the chip group's default accessor prefers `value`, and these
          // config rows carry one, but category_id has always been stored as the _id.
          getOptionValue={(category) => category?._id}
          onChange={(value, category) => {
            formik.setFieldValue("category_id", value);
            setSelectedCategory(category?.name ? [category.name] : []);
            formik.setFieldValue("sector_id", '');
            setCurrentSubCategory('');
          }}
        />
      </Grid>
      {/* </Grid> */}
      <Grid item xs={12} sm={6} mt={1}>
        {<CustomAutoComplete
          options={!isLoadingSubCategories && !isRefetchingSubCategories && Array.isArray(startup_sub_categories) ? startup_sub_categories?.map(item => ({ label: item?.sub_category, value: item?._id, description: item?.description })) : []}
          label="Select Sector"
          name={"sector_id"}
          // Sectors are fetched per category, so before one is picked the list is empty
          // by design - say that instead of the dead-end "No Options".
          noOptionsText={
            !selectedCategory?.length
              ? "Select a category first to see its sectors"
              : (isLoadingSubCategories || isRefetchingSubCategories)
                ? "Searching..."
                : "No Options"
          }
          placeholder={!selectedCategory?.length ? "Select a category first" : "Type a sector name"}
          icon={null}
          handleSearchChange={handleSearchSubCategoryChange}
          handleSelectionChange={handleSelectionSubCategoryChange}
          search={searchSubCategory}
          renderOption={(props, option) => (
            <li {...props} style={{ display: 'grid' }}>
              <span style={{ fontWeight: 600 }}>{option.label}</span>
              <p style={{ fontSize: '0.8rem' }}>{option?.description}</p>
              {/* {option.isSpecial && <span className="special-badge">Special</span>} */}
            </li>
          )}
          value={currentSubCategory}
          defaultValue={startup_sub_categories?.find(item => item?._id == formik?.values?.sector_id)}
          loading={isRefetchingSubCategories}
          handleSearchUpdate={handleSearchUpdateSubCategory}
        />}
      </Grid>
      <Grid item xs={12} sm={6} mt={1}>
        {<CustomAutoComplete
          options={!isLoadingBusinessModel && !isRefetchingBusinessModel && Array.isArray(availableOptions) ? availableOptions?.map(item => ({ label: item?.name, value: item?._id, description: item?.description })) : []}
          label="SELECT BUSINESS MODEL (MULTI SELECT)"
          name={"business_model_id"}
          multiple={true}
          noOptionsText={!isLoadingBusinessModel && !isRefetchingBusinessModel ? "No Options" : "Searching..."}
          placeholder="Business model"
          icon={null}
          handleSearchChange={handleSearchBusinessModelChange}
          handleSelectionChange={handleSelectionBusinessModelChange}
          search={searchBusinessModel}
          renderOption={(props, option) => (
            <li {...props} style={{ display: 'grid' }}>
              <span style={{ fontWeight: 600 }}>{option.label}</span>
              <p style={{ fontSize: '0.8rem' }}>{option?.description}</p>
              {/* {option.isSpecial && <span className="special-badge">Special</span>} */}
            </li>
          )}
          value={currentBusinessModel || []}
          defaultValue={startup_business_model?.filter(item => item?._id == formik?.values?.business_model_id)}
          loading={isRefetchingBusinessModel}
          handleSearchUpdate={handleSearchUpdateBusinessModel}
        />}
      </Grid>
    </>
  )
}

export default StartupInformation
